// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"4ff087c1","453":"89746a17"}[chunkId] + ".chunk.js";
};